import { IconDown } from 'icons/components/IconDown'
import { IconUpLarge } from 'icons/components/IconUpLarge'

import styles from './SelectIcon.module.scss'

interface SelectIconProps {
	readonly isMobile: boolean
	readonly disabled: boolean
	readonly open?: boolean
}

export function SelectIcon({
	isMobile,
	disabled,
	open,
}: SelectIconProps): React.ReactNode {
	return !disabled ? (
		<>
			{!isMobile && (
				<div className={styles.arrow}>
					{open ? <IconUpLarge /> : <IconDown />}
				</div>
			)}
			{isMobile && <IconDown className={styles.arrow} />}
		</>
	) : null
}
